// @flow

export const USER_EXISTS = "User already exist";
export const INVALID_LINK = "Link has expired";
export const EXPORT_NOT_ALLOWED =
  "You don't have the permission to export processes, please contact your admin.";
export const UNKNOWN_ERROR = "Unknown error occured";
export const PROCESS_DELETED = "Process was deleted";
